<template>
    <div style="margin-bottom: 55px">
        <CRow class="justify-content-center"><p style="font-size: 35px">{{ mainLabel }}</p></CRow>
        <CProgress style="height:2rem; background-color: #c4c9d094;">
            <CProgressBar
                :value="segmentStart*100"
                :striped="true"
                :style="'background-color: '+ segmentColor + `; background-image: linear-gradient(45deg,${hatchingColor} 25%,transparent 0,transparent 50%,${hatchingColor} 0,${hatchingColor} 75%,transparent 0,transparent); visibility: ${cursorPos != null ? 'visible' : 'hidden'}`"
            >
                <span style="font-size: 15px; color: #1d1b1b">{{ startLabel }}</span>
            </CProgressBar>

            <CProgressBar
                :value="(segmentEnd - segmentStart)*100"
                :style="'background-color: '+ segmentColor + `; visibility: ${cursorPos != null ? 'visible' : 'hidden'}`"
            >
                <span style="font-size: 15px; color: #1d1b1b">{{ tragetLabel }}</span>
            </CProgressBar>

            <CProgressBar
                :value="(1-segmentEnd)*100"
                :striped="true"
                :style="'background-color:' + segmentColor + `; background-image: linear-gradient(45deg,${hatchingColor} 25%,transparent 0,transparent 50%,${hatchingColor} 0,${hatchingColor} 75%,transparent 0,transparent); visibility: ${cursorPos != null ? 'visible' : 'hidden'}`"
            >
                <span style="font-size: 16px; color: #1d1b1b">{{ endLabel }}</span>
            </CProgressBar>
        </CProgress>
        <div :style="`width: 100%; position: relative; margin-top: -4px; visibility: ${cursorPos != null ? 'visible' : 'hidden'}`">
            <span :style="`font-size: 22px; position: absolute; margin-left: -10px; left: ${cursorPos*100}%; transition: all 0.8s ease 0s;`">▲</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            mainLabel: {},
            tragetLabel: {},
            startLabel: {},
            endLabel: {},
            segmentStart: {},
            segmentEnd: {},
            cursorPos: {},
            segmentColor: {},
            hatchingColor: {}
        }
    }
</script>

<style scoped>

</style>